import { Http } from '@gamiphy/http';
import { AppFreeShipping, FreeShippingCodes, UserFreeShipping } from '@gamiphy/bl/freeShipping';

export class FreeShippingApi {
  public static async getAppFreeShippingList(): Promise<AppFreeShipping[]> {
    const response = await Http.get<AppFreeShippingListResponse>({
      url: '/v2/free-shipping/apps',
    });
    return response.data.appFreeShippings;
  }

  public static async getAppFreeShipping(id: string): Promise<AppFreeShipping> {
    const response = await Http.get<AppFreeShippingResponse>({
      url: `/v2/free-shipping/apps/${id}`,
    });

    return response.data.appFreeShipping;
  }

  public static async updateAppFreeShipping(id: string, data: Partial<AppFreeShipping>): Promise<AppFreeShipping> {
    const response = await Http.patch<AppFreeShippingResponse>({
      url: `/v2/free-shipping/apps/${id}`,
      payload: {
        ...data,
      },
    });
    return response.data.appFreeShipping;
  }

  public static async createAppFreeShipping(data: Partial<AppFreeShipping>): Promise<AppFreeShipping> {
    const response = await Http.post<AppFreeShippingResponse>({
      url: '/v2/free-shipping/apps',
      payload: data,
    });
    return response.data.appFreeShipping;
  }

  public static async getCurrentUserFreeShipping(): Promise<UserFreeShipping> {
    const response = await Http.get<UserFreeShippingResponse>({
      url: '/v2/free-shipping/users',
    });
    return response.data.userFreeShipping;
  }

  public static async getUserFreeShippingList(): Promise<UserFreeShipping[]> {
    const response = await Http.get<UserFreeShippingListResponse>({
      url: '/v2/free-shipping/users/all',
    });
    return response.data.userFreeShippings;
  }

  public static async getFreeShippingCode(id: string): Promise<FreeShippingCodes> {
    const response = await Http.get<FreeShippingCode>({
      url: `/v2/free-shipping/codes/${id}`,
    });
    return response.data.freeShippingCode;
  }

  public static async updateFreeShippingCode(id: string, data: Partial<FreeShippingCodes>): Promise<FreeShippingCodes> {
    const response = await Http.patch<FreeShippingCode>({
      url: `/v2/free-shipping/codes/${id}`,
      payload: data,
    });
    return response.data.freeShippingCode;
  }

  public static async getFreeShippingCodes(): Promise<FreeShippingCodes[]> {
    const response = await Http.get<FreeShippingCodeList>({
      url: '/v2/free-shipping/codes',
    });
    return response.data.freeShippingCodes;
  }

  public static async redeemFreeShippingCode(): Promise<void> {
    await Http.post({
      url: '/v2/free-shipping/codes',
    });
  }

  public static async deleteAppFreeShipping(id: string): Promise<void> {
    await Http.delete({
      url: `/v2/free-shipping/apps/${id}`,
    });
  }

  public static async enableAppFreeShipping(id: string): Promise<AppFreeShipping> {
    const response = await Http.patch<AppFreeShippingResponse>({
      url: `/v2/free-shipping/apps/enable/${id}`,
    });
    return response.data.appFreeShipping;
  }
}

export type AppFreeShippingListResponse = {
  appFreeShippings: AppFreeShipping[]
}

export type AppFreeShippingResponse = {
  appFreeShipping: AppFreeShipping,
}

export type UserFreeShippingListResponse = {
  userFreeShippings: UserFreeShipping[],
}

export type UserFreeShippingResponse = {
  userFreeShipping: UserFreeShipping,
}

export type FreeShippingCode = {
  freeShippingCode: FreeShippingCodes,
}

export type FreeShippingCodeList = {
  freeShippingCodes: FreeShippingCodes[],
}
